const items = [
  "Hand-poured in small batches",
  "100% pure soy wax",
  "Zero paraffin · zero toxins",
  "45+ hour slow burn",
  "Perforated lantern glow",
  "Pure botanical essential oils",
  "Festive gift sets · Diwali ready",
];

export const Marquee = () => (
  <section data-testid="craft-marquee" aria-label="Our craft" className="bg-brandDarkSlate text-brandCream/90 py-6 overflow-hidden">
    <div className="flex w-max animate-marquee items-center">
      {[...items, ...items].map((text, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-serif italic text-lg sm:text-xl whitespace-nowrap px-8">{text}</span>
          <span aria-hidden className="w-1.5 h-1.5 rotate-45 bg-brandTerracotta shrink-0" />
        </span>
      ))}
    </div>
  </section>
);
